import { Order } from "@m4a3/api-client";
import { GET_DEV_ORDERS_SUCCESS, GET_FLIGHT_CARDS_SUCCESS } from "../actions/actionTypes";
import { FlightCard } from "../models/flight-card.interface";

interface FlightCardState {
  flightCards: FlightCard[];
  devOrders: Order[];
}
const initialState: FlightCardState = {
  flightCards: [],
  devOrders: [],
};

const flightCardReducer = (
  state = initialState,
  action: { type: string; payload: any }
): FlightCardState => {
  switch (action.type) {
    case GET_FLIGHT_CARDS_SUCCESS: {
      return {
        ...state,
        flightCards: action.payload
      }
    }
    case GET_DEV_ORDERS_SUCCESS: {
      return {
        ...state,
        devOrders: action.payload
      }
    }
    default:
      return state;
  }
};

export default flightCardReducer;
